import * as React from 'react';
import {Expressions, TypeImplementation} from '@packages/systems/wfdl';
import {
  type ContextualExpression,
  stripAll,
} from '@packages/utilities/contextual-expression';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {EText, TText} from '@packages/systems/wfdl-ast';
import {Select, Tooltip} from '@packages/systems/spring';
import {useTabNames} from '../TabsContext';
import {NONE_TAB_ID} from '../constants';

const NONE_SELECT_VALUE = '__none__';

const toSelectValue = (id: string) =>
  id === NONE_TAB_ID ? NONE_SELECT_VALUE : id;

const fromSelectValue = (value: string | null) =>
  value == null || value === NONE_SELECT_VALUE ? NONE_TAB_ID : value;

const DefaultTabRender = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
}) => {
  const tabs = useTabNames();
  const currentValue = Expressions.getText(stripAll(expr)) ?? NONE_TAB_ID;

  const setDefaultTab = (newValue: string | null) => {
    dispatch(updateExpressionAction(EText(fromSelectValue(newValue))));
  };

  const options = tabs.map((tab) => ({
    label: tab.id === NONE_TAB_ID ? 'None' : tab.id,
    value: toSelectValue(tab.id),
  }));

  return (
    <Tooltip label="Choose which tab is shown when the site loads">
      <Select
        options={options}
        value={toSelectValue(currentValue)}
        onChange={setDefaultTab}
        placeholder="Select tab"
      />
    </Tooltip>
  );
};

export const DefaultTabType = TypeImplementation.Alias({
  type: TText,
  render: DefaultTabRender,
});
